import { LocalizedText, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { SettlementRuleMappedEntitiesResult } from '@mews-commander/data-access';

interface Props {
    textKey: Mews.TextKey;
    data: SettlementRuleMappedEntitiesResult;
    zeroCountTextKey?: Mews.TextKey;
}

export const MessageWithEntitiesCount = ({ textKey, zeroCountTextKey, data: { rateGroups, rates } }: Props) => {
    const localizeText = useLocalizeText();

    const rateGroupsLocalized = localizeText({
        textKey: TextKey.RateGroupCount,
        substitutes: { count: rateGroups.length },
    });
    const ratesLocalized = localizeText({ textKey: TextKey.RateCount, substitutes: { count: rates.length } });
    const isEntitiesCountZero = rateGroups.length === 0 && rates.length === 0;
    const textKeyToUse = isEntitiesCountZero && zeroCountTextKey ? zeroCountTextKey : textKey;

    return (
        <LocalizedText
            textKey={textKeyToUse}
            substitutes={{ rateGroups: rateGroupsLocalized, rates: ratesLocalized }}
        />
    );
};
